var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTireHollow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.876 1.856a.508.508 0 0 1 .753.131c.152.238.091.55-.123.734a6.966 6.966 0 0 0-.219.194L5.656 6.08a.533.533 0 0 1-.49.849L1.238 6.46a6.957 6.957 0 0 0 0 3.078l3.928-.469a.533.533 0 0 1 .49.85l-2.369 3.165a6.925 6.925 0 0 0 2.665 1.54L7.51 10.99a.533.533 0 0 1 .98 0l1.558 3.636a6.924 6.924 0 0 0 2.665-1.54L10.344 9.92a.533.533 0 0 1 .49-.85l3.928.469a6.954 6.954 0 0 0 0-3.078l-3.928.469a.533.533 0 0 1-.49-.85l2.369-3.165a6.925 6.925 0 0 0-2.665-1.54L8.49 5.01a.533.533 0 0 1-.98 0L5.952 1.374a6.86 6.86 0 0 0-.236.078.57.57 0 0 1-.672-.222.509.509 0 0 1 .243-.758 8 8 0 1 1-2.41 1.384zM2.55 3.712a6.925 6.925 0 0 0-.99 1.713l2.495.298-1.505-2.011zm9.393 6.565 2.495.298a6.92 6.92 0 0 1-.99 1.713l-1.505-2.011zm-10.384.298c.249.62.584 1.196.991 1.713l1.505-2.011-2.496.298zm10.384-4.852 1.504-2.011c.408.517.743 1.093.992 1.713l-2.496.298zm-4.934 9.14a6.992 6.992 0 0 0 1.98 0L8 12.553l-.99 2.31zM8 3.446l-.99-2.31a6.992 6.992 0 0 1 1.98 0L8 3.447zm0 3.22a1.333 1.333 0 1 0 0 2.667 1.333 1.333 0 0 0 0-2.666zM7.733 8a.267.267 0 1 1 .534 0 .267.267 0 0 1-.534 0z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTireHollow);
export default __webpack_public_path__ + "static/media/tire-hollow.7560a4ce59ac54aa9ad7162a52417cc1.svg";
export { ForwardRef as ReactComponent };